// extracted by mini-css-extract-plugin
module.exports = {"container":"modal_container__yUcUZ","footerBox":"modal_footerBox__3zrvx"};